import { HtsButtonIcon, HtsTypography, HtslIcon } from '@hts/shared/ui';
import { memo, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import Slider, { Settings } from 'react-slick';
import styles from '../styles/VideoListSection.module.scss';
import { DetailedVideo } from './DetailedVideo';
import { useIsMobile } from '@hts/shared/libs';

interface IVideoListSectionProps {
  label: string;
  linkTo: string;
}

export const VideoListSection: React.FC<IVideoListSectionProps> = memo(({ label, linkTo }) => {
  const sliderRef = useRef<Slider>(null);

  const videos = [1, 2, 3];
  const isMobile = useIsMobile();

  const sliderSettings: Settings = {
    infinite: false,
    arrows: false,
    centerMode: false,
    swipeToSlide: true,
    variableWidth: true,
  };

  const handlePrev = useCallback(() => {
    sliderRef.current?.slickPrev();
  }, []);

  const handleNext = useCallback(() => {
    sliderRef.current?.slickNext();
  }, []);

  const renderVideo = useCallback((item, index: number) => <DetailedVideo key={index} />, []);

  return (
    <div className={styles.container}>
      <div className={styles.labelContainer}>
        <HtsTypography variant="h1">{label}</HtsTypography>

        <Link to={linkTo} className={styles.seeAllLink}>
          <HtsTypography fontWeight="500" variant={isMobile ? 'subtitle' : 'body1'}>
            See all
          </HtsTypography>

          <HtslIcon icon="arrow-right" />
        </Link>
      </div>

      <div className={styles.sliderContainer}>
        <HtsButtonIcon className={styles.arrowLeftButton} onClick={handlePrev}>
          <HtslIcon icon="keyboard-arrow-left" />
        </HtsButtonIcon>

        <Slider {...sliderSettings} ref={sliderRef} className={styles.slideContainer}>
          {videos.map(renderVideo)}
        </Slider>

        <HtsButtonIcon className={styles.arrowRightButton} onClick={handleNext}>
          <HtslIcon icon="keyboard-arrow-right" />
        </HtsButtonIcon>
      </div>
    </div>
  );
});
